import { render, staticRenderFns } from "./openVIP.vue?vue&type=template&id=1f7157f7&scoped=true&"
import script from "./openVIP.vue?vue&type=script&lang=js&"
export * from "./openVIP.vue?vue&type=script&lang=js&"
import style0 from "./openVIP.vue?vue&type=style&index=0&id=1f7157f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7157f7",
  null
  
)

export default component.exports